function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.615 11.033h-2.23A2.306 2.306 0 019.082 8.73a2.306 2.306 0 012.303-2.304h4.46a1.04 1.04 0 000-2.082H13.54V2.041a1.04 1.04 0 00-2.082 0v2.303h-.074A4.39 4.39 0 007 8.73a4.39 4.39 0 004.385 4.385h2.23a2.306 2.306 0 012.303 2.303 2.306 2.306 0 01-2.303 2.304h-4.46a1.04 1.04 0 000 2.082h2.304v2.303a1.04 1.04 0 002.082 0v-2.303h.074A4.39 4.39 0 0018 15.419a4.39 4.39 0 00-4.385-4.386z",
  fill: "#000"
});

function SvgDollar(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
}

export default SvgDollar;